import { SESSION_PALETTE } from './session-palette';

/**
 * Cor de fundo padrão de uma sessão: a primeira da paleta canônica.
 *
 * Fonte ÚNICA no frontend — o valor estava repetido literalmente em oito
 * lugares (diálogos de sessão, calendário, lista de sessões), o que já tinha
 * produzido divergência com o backend, cujo default era outro azul (`#ABCFF3`),
 * hoje alinhado. Derivar da paleta evita o mesmo erro em outra escala: a cor
 * padrão é, por definição, a primeira amostra que o usuário vê no seletor.
 */
export const DEFAULT_SESSION_COLOR = SESSION_PALETTE[0].hex;
